<template>
  <MapModal
    :modalNode="modalNode"
    :close="cancel"
    :title="stationQueryTitle"
    id="stationQuery"
  >
    <template slot="content">
      <div class="stationQueryForm">
        <!-- <p @click="text">测试</p> -->
        <schemeDesignLine
          ref="schemeDesignLine"
          @getPlanGuid="getPlanGuid($event)"
          @getDesignLineGuid="getDesignLineGuid($event)"
        ></schemeDesignLine>
      </div>
    </template>
    <template slot="foot">
      <div class="foot-operate">
        <el-button type="primary" @click="onSubmit">
          查询
        </el-button>
      </div>
    </template>
  </MapModal>
</template>
<script>
//按需加载
import { getMileageStakesAndPoints } from "@/api/api";
const MapModal = () => import("@/components/common/mapModal/Index");
const schemeDesignLine = () =>
  import("@/components/tables/routeInteraction/schemeDesignLine.vue");
import * as mapWork from "./map.js";
import DrawstraightArrow from "./drawstraightArrow";
// window.drawstraightArrow = new drawstraightArrow();
export default {
  name: "hundred-stake",
  props: ["close"],
  components: { MapModal, schemeDesignLine },
  data() {
    return {
      stationQueryTitle: "绘制百米桩",
      modalNode: {
        trafficSimulationAdd: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      planGuid: null,
      designLineGuid: null,
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    showHectometerStake(arr) {
      let newArr = [];
      arr.forEach((item) => {
        newArr.push({
          position: [item.l, item.b, item.h],
          text: item.stake,
        });
      });
      mapWork.drawDots(newArr);
    },
    cancel() {
      mapWork.init();
      this.close();
    },
    getPlanGuid(data) {
      this.planGuid = data;
    },
    getDesignLineGuid(data) {
      this.designLineGuid = data;
    },
    onSubmit() {
      if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      mapWork.init();
      const params = {
        planGuid: this.planGuid,
        designLineGuid: this.designLineGuid,
      };
      getMileageStakesAndPoints(params)
        .then((res) => {
          this.showHectometerStake(res.data.data);
        })
        .catch((error) => {
          this.$notify({
            title: "查询失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
    // text() {
    //   window.drawstraightArrow = new DrawstraightArrow(this.$GLOBAL.map);
    //   drawstraightArrow.startCreate();
    // },
    init() {
      // mapWork.refresh();
      // this.showHectometerStake();
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    // console.log("销毁了？");
    this.clearDots();
  },
  watch: {},
  destroyed() {
    this.cancel();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.el-form {
  width: 100%;
  padding: 0 !important;
  /deep/ .el-radio-group {
    margin-top: 7px !important;
  }
  /deep/ .el-form-item {
    width: 100%;
    padding: 0 0 0 18px;
    margin: 20px 0px;
    margin-top: 0;
    .el-form-item__label {
      min-height: 1px;
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding-right: 10px;
      line-height: 32px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      min-height: 32px;
      .el-select {
        @include select_base();
      }
      .el-input {
        @include input_base();
        width: auto;
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .el-input__inner {
      width: 100% !important;
    }
    .el-input-group__prepend {
      border-color: rgba(245, 245, 245, 0.6) !important;
      color: rgba(255, 255, 255, 0.9) !important;
      background: none;
      padding: 0 10px;
    }
    &.btns {
      padding: 6px 0 0 89px;
      .el-form-item__content {
        width: auto;
        .el-button--primary {
          @include lheight(28);
          @include font_color("t_color_op1");
          @include background_color("t_color1_op2");
          @include border_color("t_color1_op2");
          padding: 0 15px;
          margin: 6px 16px 0 0;
          span {
            @include lheight(28);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color1_op1");
            @include border_color("t_color1_op1");
          }
          &.is-disabled {
            // @include font_color("t_color_sc1");
            // @include background_color("t_color1_op3");
            @include border_color("t_color1_op3");
            background-color: rgba(42, 183, 255, 0.4) !important;
            color: rgba(255, 255, 255, 0.9) !important;
            &:hover {
              background-color: rgba(42, 183, 255, 0.4) !important;
            }
            span {
              background: none;
              // @include font_color("t_color_sc1");
            }
          }
        }
        .el-button--default {
          @include lheight(28);
          @include font_color("t_color_op2");
          @include background_color("t_color3_op2");
          @include border_color("t_color_op2");
          padding: 0 15px;
          margin: 6px 16px 0 6px;
          span {
            @include lheight(24);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color3_op1");
            @include border_color("t_color_op1");
            @include font_color("t_color_op1");
          }
        }
      }
    }
    // &:first-child {
    //   padding: 10px 0 0 18px;
    // }
  }
  .main .el-form-item.btns {
    // padding: 0;
    // margin: 0;
    .el-form-item__content .el-button--primary {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 20px;
    }
  }
  .rich {
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item__content {
      width: 100% !important;
      margin: 0 !important;
    }
  }
}
.flexRight {
  display: flex;
  padding: 20px 0px;
  margin-right: -16px;
  align-items: center !important;
  width: 100%;
  justify-content: flex-end;
}
/deep/ .el-form.settings,
.el-form {
  padding: 0;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  .el-button {
    margin: 0 5px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.stationQueryForm {
  padding: 8px 36px 17px 0;
}
</style>
